import type { DemoLanguage } from '@/types/demo';

type LanguageFlagProps = {
  language: DemoLanguage;
  className?: string;
};

/**
 * Compact SVG flags for the demo language picker.
 */
export function LanguageFlag({ language, className = 'h-5 w-7' }: LanguageFlagProps) {
  if (language === 'es') {
    return (
      <svg
        className={className}
        viewBox="0 0 21 15"
        aria-hidden="true"
        focusable="false"
      >
        <rect width="21" height="15" rx="2" fill="#C60B1E" />
        <rect y="3.75" width="21" height="7.5" fill="#FFC400" />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      viewBox="0 0 21 15"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="21" height="15" rx="2" fill="#012169" />
      <path stroke="#fff" strokeWidth="3" d="M0 0l21 15M21 0L0 15" />
      <path stroke="#C8102E" strokeWidth="2" d="M0 0l21 15M21 0L0 15" />
      <path stroke="#fff" strokeWidth="5" d="M10.5 0v15M0 7.5h21" />
      <path stroke="#C8102E" strokeWidth="3" d="M10.5 0v15M0 7.5h21" />
    </svg>
  );
}
